import commonStyles from 'utils/commonStyles';

const styles = () => ({
  title: {
    flex: 1,
  },
  inputContainer: {
    marginBottom: '24px',
  },
  buttonContainer: {
    marginRight: '12px',
  },
  ...commonStyles,
});

export default styles;
